import { SVGProps } from "react";

const Back = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25.033}
    height={18.196}
    data-name="Group 11031"
    viewBox="0 0 26 19"
    {...props}
  >
    <defs>
      <clipPath id="a">
        <path
          fill="#404040"
          d="M0 0h25.033v18.196H0z"
          data-name="Rectangle 4828"
        />
      </clipPath>
    </defs>
    <g clipPath="url(#a)" data-name="Group 11030">
      <path
        fill="#404040"
        d="M3.991 7.971H23.641a2.169 2.169 0 0 1 .579.055 1.131 1.131 0 0 1-.213 2.21 4.133 4.133 0 0 1-.425.015H3.988l-.093.123a.957.957 0 0 1 .259.132q2.831 2.82 5.656 5.647a1.169 1.169 0 0 1 .355 1.278 1.136 1.136 0 0 1-1.811.49c-.067-.057-.129-.122-.191-.185L.477 10.054a1.169 1.169 0 0 1 0-1.888Q4.372 4.276 8.263.387a1.137 1.137 0 0 1 1.782.087A1.122 1.122 0 0 1 10 1.856a3.66 3.66 0 0 1-.256.271Q6.96 4.916 4.17 7.7a1.743 1.743 0 0 1-.238.17l.06.1"
        data-name="Path 19517"
      />
    </g>
  </svg>
);
export default Back;
